import { render, staticRenderFns } from "./PrivateCustomerForm.vue?vue&type=template&id=0545ba06&scoped=true"
import script from "./PrivateCustomerForm.vue?vue&type=script&lang=js"
export * from "./PrivateCustomerForm.vue?vue&type=script&lang=js"
import style0 from "./PrivateCustomerForm.vue?vue&type=style&index=0&id=0545ba06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0545ba06",
  null
  
)

export default component.exports